// extracted by mini-css-extract-plugin
module.exports = {"container":"base_container__zs4Az","no-layout":"base_no-layout__Wy3fC","no-btm-nav":"base_no-btm-nav__OBI39","mobile-header":"base_mobile-header___VSxL"};